import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    Button,
    Grid,
} from "@mui/material";
import { useMediaQueries } from "../usecontext/UseProvider";
import { getAboutGallery } from "../services/AboutGallery";
import Header from '../adminComponents/header/Header'
import AboutGalleryModal from "../adminComponents/aboutgallerymodal/AboutGalleryModal";

const AboutGallaryPage = () => {
    const { isSmallScreen, setLoading } = useMediaQueries();
    const [aboutGalleryData, setAboutGalleryData] = useState([]);
    const [openModal, setOpenModal] = useState(false);

    const getAboutGalleryData = async () => {
        try {
            setLoading(true);
            const response = await getAboutGallery();
            setAboutGalleryData(response?.aboutGalleryData);
            setLoading(false);
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    useEffect(() => {
        getAboutGalleryData();
    }, []);

    const handleOnEdit = () => {
        setOpenModal(true);
    };

    const handleUpdateSuccess = (updatedData) => {
        setAboutGalleryData(updatedData);
    };

    return (
        <>
            <Header title="About Story" />
            <Box sx={{ pt: 3 }}>
                <Grid container spacing={4} alignItems="center">
                    <Grid item xs={12} md={6} data-aos="fade-right">
                        <Typography
                            variant={"h4"}
                            sx={{ fontWeight: "bold", marginBottom: 5, color: '#000' }}
                        >
                            {aboutGalleryData?.title}
                        </Typography>
                        {aboutGalleryData?.description?.map((item, index) => (
                            <Typography
                                variant={"body1"}
                                sx={{ fontSize: "22px", color: '#000' }}
                                key={index}
                            >
                                {item}
                            </Typography>
                        ))}
                        <Button
                            variant="varient"
                            size={isSmallScreen ? 'small' : 'medium'}
                            sx={{
                                fontWeight: 400,
                                backgroundColor: '#01A0E2',
                                color: '#fff',
                                mt: { md: 4, xs: 0 },
                                px: { md: 6 },
                                fontSize: { md: '20px' }, borderRadius: '10px'
                            }}
                            onClick={handleOnEdit}>
                            Change Image and Text
                        </Button>
                    </Grid>

                    <Grid item xs={12} md={6} textAlign="center" data-aos="fade-left">
                        <Grid container spacing={2} justifyContent="center">
                            {aboutGalleryData?.images?.map((image, index) => (
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={6}
                                    key={index}
                                    data-aos="zoom-in"
                                    data-aos-delay={index * 100}
                                >
                                    <Box
                                        component="img"
                                        src={image?.url}
                                        alt={`Swing ${index + 1}`}
                                        sx={{
                                            width: "100%",
                                            height: "240px",
                                            objectFit: "cover",
                                        }}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
            <AboutGalleryModal 
                open={openModal} 
                setOpen={setOpenModal} 
                aboutGalleryData={aboutGalleryData} 
                onUpdateSuccess={handleUpdateSuccess}
            />
        </>
    )
}

export default AboutGallaryPage